import type { InteractionState } from '@spawnwire/shared';
import { errorMessage, http } from '../../lib/api';
import { ui } from '../../store/ui';
import { closeForm, upsertInteraction } from './slashCommands';

/**
 * Clicking a bot's button or choosing from its menu. The server checks the click against the message, and the
 * bot's answer arrives like a command's: as a changed message, a new one, or an `interaction:update`.
 */
export async function clickComponent(channelId: string, messageId: string, customId: string, values: string[] = []): Promise<boolean> {
  try {
    upsertInteraction(await http.post<InteractionState>(`/channels/${channelId}/messages/${messageId}/components`, { customId, values }));
    return true;
  } catch (err) {
    ui.toast(errorMessage(err), 'error');
    return false;
  }
}

/** Sends a filled-in form. Failures are thrown so the dialog can show them next to the fields. */
export async function submitForm(interactionId: string, values: Record<string, string>): Promise<void> {
  const state = await http.post<InteractionState>(`/interactions/${interactionId}/modal`, { values });
  closeForm(interactionId);
  upsertInteraction(state);
}
